var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonTooltip',_vm._g(_vm._b({attrs:{"text":"","icon":"","x-small":_vm.$vuetify.breakpoint.xsOnly || _vm.$device.isIos,"tooltip-props":{
    top: true,
    bottom: false,
    nudgeTop: '11',
    transition: 'none',
    disabled: !_vm.$vuetify.breakpoint.mdAndUp || _vm.$device.isIos,
  },"icon-name":_vm.iconName,"button-class":"white--text"}},'ButtonTooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }